<template>
  <div ref="intersectionContainer">
    <div
      style="display: flex; justify-content: space-between; align-items: center;"
    >
      <h1>Заявки</h1>
      <el-link
        type="primary"
        v-if="getTelegramLink"
        :href="getTelegramLink"
        target="_blank"
      >
        <i class="el-icon-s-promotion"></i>
        Подписаться на уведомления в телеграмм
      </el-link>
      <UnreadRequests />
    </div>

    <el-table
      class="m-t-10"
      height="720"
      :data="requests"
      v-loading="loading"
      :row-class-name="tableRowClassName"
    >
      <el-table-column prop="number" label="№ заявки" width="100" />
      <el-table-column prop="subject" label="Тема обращения" />
      <el-table-column label="Телефон/E-mail" align="center">
        <template #default="{row}">
          <div>{{ row.phone }}</div>
          <div>{{ row.email }}</div>
        </template>
      </el-table-column>

      <el-table-column label="Дата" width="100" align="center">
        <template #default="{row}">
          {{ parseDate(row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column label="Статус" width="140" align="center">
        <template #default="{row}">
          <Status :status="row.status" />
        </template>
      </el-table-column>
      <el-table-column width="140">
        <template #header>
          <el-button
            size="small"
            icon="el-icon-download"
            type="primary"
            @click="save"
          >
            Сохранить
          </el-button>
        </template>
        <template #default="{row}">
          <el-button @click="toRequestPage(row.id)" size="small">
            Открыть заявку
          </el-button>
        </template>
      </el-table-column>
      <template #append>
        <div ref="observerTrigger"></div>
      </template>
    </el-table>
  </div>
</template>

<script>
import { parseDate } from "@/plugins/dateParser";
import Status from "./components/Status";
import UnreadRequests from "./components/UnreadRequests";
import { mapGetters } from "vuex";

export default {
  components: { Status, UnreadRequests },
  data() {
    return {
      requests: [],
      loading: false,
      page: 1,
      total: 0,
      pageSize: 20,
      observer: undefined
    };
  },
  computed: {
    ...mapGetters(["getTelegramLink"]),
    lastPage() {
      return Math.ceil(this.total / this.pageSize);
    }
  },
  methods: {
    tableRowClassName(e) {
      if (e.row.isUnread) {
        return "new-request";
      } else if (e.row.hasUnreadComments) {
        return "new-comment";
      } else {
        return "";
      }
    },
    parseDate(d) {
      return parseDate(d);
    },
    toRequestPage(id) {
      this.$router.push(`/requests/${id}`);
    },
    async fetchTelegramLink() {
      try {
        await this.$store.dispatch("fetchTelegramLink");
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }
    },
    async fetchRequests() {
      try {
        this.loading = true;
        const result = await this.$store.dispatch("fetchRequests", {
          skip: (this.page - 1) * this.pageSize,
          take: this.pageSize
        });
        if (result) {
          this.requests = result.data;
          this.total = result.totalItems;
        }
        this.$store.dispatch("fetchUnreadRequests");
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      } finally {
        this.loading = false;
        if (this.lastPage > this.page) {
          this.createObserver();
        }
      }
    },
    async fetchNextRequests() {
      try {
        if (this.lastPage > this.page) {
          this.page++;
          const result = await this.$store.dispatch("fetchRequests", {
            skip: (this.page - 1) * this.pageSize,
            take: this.pageSize
          });
          if (result) {
            this.requests = [...this.requests, ...result.data];
            this.total = result.totalItems;
          }
        } else {
          this.unobserveIntersecting();
        }
      } catch (error) {
        this.error = this.$ErrorsMod(e);
      }
    },

    createObserver() {
      const callback = e => {
        if (e[0].isIntersecting) {
          this.fetchNextRequests();
        }
      };
      const options = {
        root: this.$refs.intersectionContainer,
        rootMargin: "0px",
        threshold: 0
      };
      this.observer = new IntersectionObserver(callback, options);
      this.observer.observe(this.$refs.observerTrigger);
    },
    unobserveIntersecting() {
      if (this.$refs.observerTrigger) {
        this.observer.unobserve(this.$refs.observerTrigger);
      }
    },
    async save() {
      if (this.total) {
        try {
          const result = await this.$store.dispatch("fetchRequests", {
            skip: 0,
            take: this.total
          });

          const statuses = [
            {
              title: "Новая",
              value: 0,
              color: "warning"
            },
            {
              title: "Новая",
              value: 7,
              color: "warning"
            },
            {
              title: "Отменена",
              value: 1,
              color: "danger"
            },
            {
              title: "Создана",
              value: 2,
              color: "primary"
            },
            {
              title: "В работе",
              value: 3,
              color: "primary"
            },
            {
              title: "Завершена",
              value: 4,
              color: "success"
            },
            {
              title: "Закрыта",
              value: 5,
              color: "success"
            },
            {
              title: "Приостановлена",
              value: 6,
              color: "info"
            },
            // этот статус считается равнозначным Новой
            // {
            //   name: "Sended",
            //   title: "Отправлена",
            //   value: 7
            // },

            {
              title: "без статуса",
              value: null,
              color: "#000"
            }
          ];

          let savedObj = [
            "№ заявки",
            "Тема обращения",
            "Телефон",
            "E-mail",
            "Дата",
            "Статус"
          ].join(",");

          result.data.forEach(item => {
            const row = [];
            row.push(item.number || "-");
            row.push(item.subject || "-");
            row.push(item.phone || "-");
            row.push(item.email || "-");
            row.push(parseDate(item.createdAt));
            const status = statuses.find(val => val.value === item.status);
            if (status) {
              row.push(status.title);
            } else {
              row.push("-");
            }
            const rowStr = row.join(",");

            savedObj = savedObj + "\n" + rowStr;
          });
          let blob = new Blob([savedObj], { type: "text/html" });

          const link = document.createElement("a");
          link.download = `Заявки на ${new Date().toLocaleDateString()}.csv`;
          link.href = URL.createObjectURL(blob);
          link.click();
          URL.revokeObjectURL(link.href);
        } catch (e) {
          this.$ErrorsMod(e);
        }
      }
    }
  },
  mounted() {
    this.fetchRequests();
    this.fetchTelegramLink();
  }
};
</script>

<style scoped>
::v-deep .el-table .new-comment {
  background: #fdf6ec;
}
::v-deep .el-table .new-request {
  background: #d9ecff;
}
</style>
